import apiClient from './client';

export type VisitStatus = 'green' | 'yellow' | 'red' | 'gray';
export type GeocodingConfidence = 'high' | 'medium' | 'low' | null;

export interface MapFamily {
  id: string;
  name: string;
  display_name?: string;
  initials: string;
  address: string | null;
  numar: string | null;
  bloc: string | null;
  scara: string | null;
  etaj: string | null;
  apartament: string | null;
  city: string | null;
  latitude: number;
  longitude: number;
  sector_id: string | null;
  geocoding_confidence: GeocodingConfidence;
  needs_geocoding: boolean;
  visit_status: VisitStatus;
  last_visit_date: string | null;
  last_ajutor_date: string | null;
  last_visit_type: string | null;
  last_pastoral_visit_date: string | null;
  pastoral_visit_status: VisitStatus;
  head_phone: string | null;
  sector?: {
    id: string;
    name: string;
    color: string | null;
  } | null;
}

export interface MapFilters {
  sector_id?: string;
  visit_status?: VisitStatus;
  ajutoare_filter?: 'received' | 'not_received';
  ajutoare_months?: number;
  sw_lat?: number;
  sw_lng?: number;
  ne_lat?: number;
  ne_lng?: number;
}

export async function getMapFamilies(
  params?: MapFilters,
): Promise<MapFamily[]> {
  const response = await apiClient.get<{ data: MapFamily[] }>(
    '/map/families',
    { params },
  );
  return response.data.data;
}

export interface PendingFamily {
  id: string;
  name: string;
  display_name: string;
  address: string | null;
  numar: string | null;
  bloc: string | null;
  scara: string | null;
  etaj: string | null;
  apartament: string | null;
  city: string | null;
  sector_id: string | null;
  geocoding_confidence: GeocodingConfidence;
  needs_geocoding: boolean;
  sector?: {
    id: string;
    name: string;
    color: string | null;
  } | null;
}

export async function getPendingReview(
  params?: { sector_id?: string },
): Promise<PendingFamily[]> {
  const response = await apiClient.get<{ data: PendingFamily[] }>(
    '/map/families/pending-review',
    { params },
  );
  return response.data.data;
}

export async function updateFamilyLocation(
  familyId: string,
  latitude: number,
  longitude: number,
): Promise<void> {
  await apiClient.put(`/map/families/${familyId}/location`, {
    latitude,
    longitude,
  });
}

export interface MapMember {
  id: string;
  full_name: string;
  first_name: string;
  last_name: string;
  middle_name: string | null;
  initials: string;
  address: string | null;
  numar: string | null;
  bloc: string | null;
  scara: string | null;
  etaj: string | null;
  apartament: string | null;
  city: string | null;
  latitude: number;
  longitude: number;
  sector_id: string | null;
  cell_phone: string | null;
  home_phone: string | null;
  phone: string | null;
  geocoding_confidence: GeocodingConfidence;
  needs_geocoding: boolean;
  sector?: {
    id: string;
    name: string;
    color: string | null;
  } | null;
}

export async function getMapMembers(
  params?: MapFilters,
): Promise<MapMember[]> {
  const response = await apiClient.get<{ data: MapMember[] }>(
    '/map/members',
    { params },
  );
  return response.data.data;
}

export interface PendingMember {
  id: string;
  full_name: string;
  first_name: string;
  last_name: string;
  address: string | null;
  numar: string | null;
  bloc: string | null;
  scara: string | null;
  etaj: string | null;
  apartament: string | null;
  city: string | null;
  sector_id: string | null;
  geocoding_confidence: GeocodingConfidence;
  needs_geocoding: boolean;
  sector?: {
    id: string;
    name: string;
    color: string | null;
  } | null;
}

export async function getPendingReviewMembers(
  params?: { sector_id?: string },
): Promise<PendingMember[]> {
  const response = await apiClient.get<{ data: PendingMember[] }>(
    '/map/members/pending-review',
    { params },
  );
  return response.data.data;
}

export async function updateMemberLocation(
  memberId: string,
  latitude: number,
  longitude: number,
): Promise<void> {
  await apiClient.put(`/map/members/${memberId}/location`, {
    latitude,
    longitude,
  });
}
